import ReactGA from 'react-ga4';

let isGoogleAnalyticsInitialized = false;

function getConfiguredValue(value) {
    if (typeof value !== 'string') {
        return null;
    }

    const trimmedValue = value.trim();
    return trimmedValue.length > 0 ? trimmedValue : null;
}

export function getGaMeasurementId(hostname = window.location.hostname) {
    const configuredWebsite = process.env.REACT_APP_WEBSITE;
    const gaIdCom = getConfiguredValue(process.env.REACT_APP_GA4_ID_COM);
    const gaIdNl = getConfiguredValue(process.env.REACT_APP_GA4_ID_NL);

    const isDutchWebsite = hostname.includes('.nl') || configuredWebsite === 'nl';
    return isDutchWebsite ? gaIdNl : gaIdCom;
}

export function initializeGoogleAnalytics(hostname = window.location.hostname) {
    if (isGoogleAnalyticsInitialized) {
        return true;
    }

    const measurementId = getGaMeasurementId(hostname);
    if (!measurementId) {
        return false;
    }

    ReactGA.initialize(measurementId);
    isGoogleAnalyticsInitialized = true;
    return true;
}

export function trackGoogleAnalyticsPageView(pathname) {
    if (!isGoogleAnalyticsInitialized) {
        return;
    }

    ReactGA.send({ hitType: 'page_view', page: pathname, title: 'GA4' });
}
